import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'default-modal-header',
  standalone: false,
  templateUrl: './default-modal-header.component.html',
  styleUrls: ['./default-modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefaultModalHeaderComponent {
  title = input<string | undefined>(undefined);
  description = input<string | undefined>(undefined);
}
